import styled from 'styled-components';
import { CLARET } from '../constants/colors';
import { darken } from 'polished';

const Button = styled.button`
  font-family: Roboto, sans-serif;
  background: ${CLARET};
  color: white;
  padding: 15px 24px;
  border: none;
  font-size: 1rem;
  font-weight: 700;
  transition: background ease-in-out 0.3s;

  &:hover {
    background: ${darken(0.05, CLARET)};
  }
`;

export default Button;
